import React from 'react';
import { useBwicTableContext } from '@/finsight/application/Bonds/BwicTableContext';
import { useFiltersContext } from '@/finsight/application/FiltersContext';
import useReduxSelector from '@/Framework/hooks/useReduxSelector';
import Bwic from './Bwic';

const stateSelector = (state) => ({
  pathname: state.router.location.pathname,
});

const BwicContainer = (props) => {
  const reduxProps = useReduxSelector(stateSelector);
  const {
    bwicsData: { bwics: { collection: data, totalCount } },
    isBwicFetching: isFetching,
  } = useBwicTableContext();

  const {
    handlePageChange,
    handlePerPageChange,
    handleSortChange,
    params: {
      page,
      perPage,
      sortBy,
      sortOrder,
    },
  } = useFiltersContext();

  return (
    <Bwic
      { ...props }
      { ...reduxProps }
      isFetching={ isFetching }
      data={ data }
      totalCount={ totalCount }
      page={ page }
      perPage={ perPage }
      sortBy={ sortBy }
      sortOrder={ sortOrder }
      paginate={ handlePageChange }
      itemsPerPage={ handlePerPageChange }
      sort={ handleSortChange }
    />
  );
};

export default BwicContainer;
